import React, { useEffect, useState } from "react";
import api from "../../api";
import { useAuth } from "../../AuthContext";
import SignatureEnrollment from "./SignatureEnrollment";
import { messageOf } from "./SignatureApi";

export default function EnrollmentGate({
  children,
  onClose,
  externalToken,
  onCertificate,
  strict = false,
  review,
}) {
  const { user } = useAuth();
  const [state, setState] = useState(null),
    [error, setError] = useState("");
  const load = () =>
    api.get("/signatures/enrollment/status").then((r) => {
      setState(r.data);
      setError("");
    });
  useEffect(() => {
    if (!user || externalToken) return;
    let alive = true;
    api
      .get("/signatures/enrollment/status")
      .then((r) => {
        if (alive) setState(r.data);
      })
      .catch((e) => {
        if (alive) setError(messageOf(e));
      });
    return () => {
      alive = false;
    };
  }, [user?.id, user?.isMaster, externalToken]);
  useEffect(() => {
    if (!user || externalToken || !strict) return;
    let alive = true;
    const refresh = () =>
      api
        .get("/signatures/enrollment/status")
        .then(({ data }) => {
          if (alive) {
            setState(data);
            setError("");
          }
        })
        .catch((e) => {
          if (alive) setError(messageOf(e));
        });
    window.addEventListener("focus", refresh);
    window.addEventListener("signature-enrollment-changed", refresh);
    return () => {
      alive = false;
      window.removeEventListener("focus", refresh);
      window.removeEventListener("signature-enrollment-changed", refresh);
    };
  }, [user?.id, user?.isMaster, externalToken, strict]);
  if (!user && strict)
    return <p role="status">Aguarde a autenticação da sua conta…</p>;
  // Masters without a requested change keep configuration access without enrollment.
  if (
    !user ||
    externalToken ||
    (user.isMaster === true &&
      !state?.control?.blocked &&
      !state?.control?.requested)
  )
    return children;
  if (error)
    return (
      <div className="signature-panel">
        <p role="alert" className="signature-error">
          {error}
        </p>
        <button onClick={() => load().catch((e) => setError(messageOf(e)))}>
          Tentar novamente
        </button>
        {onClose && !strict && <button onClick={onClose}>Fechar</button>}
      </div>
    );
  if (!state) return <p role="status">Verificando habilitação da sua conta…</p>;
  if (
    !state.control?.blocked &&
    !state.control?.requested &&
    ((!strict && !state.policy?.enabled) ||
      (state.enrollment?.status === "APPROVED" &&
        state.enrollment.currentPolicy))
  )
    return children;
  return (
    <div
      className={
        strict ? "signature-panel signature-enrollment-required" : undefined
      }
    >
      {onCertificate && (
        <button onClick={onCertificate}>Usar certificado digital</button>
      )}
      {review}
      <SignatureEnrollment
        onClose={strict ? undefined : onClose}
        onApproved={() => load().catch((e) => setError(messageOf(e)))}
      />
    </div>
  );
}
